import { getGroupRoles } from "@api/groups";
import type { GroupRole } from "@api/groups/types";
import { type ParentComponent, Show, createContext, createResource } from "solid-js";

export const groupRolesContext = createContext<GroupRole[]>([]);

export const GroupRolesProvider: ParentComponent = (props) => {
	const [roles] = createResource(getGroupRoles);

	return (
		<Show when={roles.latest}>
			<groupRolesContext.Provider value={roles() ?? []}>{props.children}</groupRolesContext.Provider>
		</Show>
	);
};
